import Vue from 'vue'
import VueRouter from 'vue-router'

import LoginView from '../views/LoginView.vue'
import IndexView from '../views/Back/IndexView.vue'

import CompanyListView from '../views/Back/Company/CompanyListView.vue'
import PermissionListView from '../views/Back/Permission/PermissionListView.vue'

const originalPush = VueRouter.prototype.push;
const originalReplace = VueRouter.prototype.replace;

// 重写push方法
VueRouter.prototype.push = function(location) {
  return originalPush.call(this, location).catch(err => err);
};

// 重写replace方法
VueRouter.prototype.replace = function(location) {
  return originalReplace.call(this, location).catch(err => err);
};

Vue.use(VueRouter)

const routes = [
  {
    path: '/Login',
    name: 'LoginView',
    component: LoginView
  },
  {
    path: '/',
    name: 'IndexView',
    component: IndexView,
    children: [
      {
        path: '/Company/List',
        name: 'CompanyListView',
        component: CompanyListView
      },
      {
        path: '/Permission/List',
        name: 'PermissionListView',
        component: PermissionListView
      },
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
